import { Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Sticky from 'react-sticky-el'
import NavBarTop from '../../components/NavBarTop'
import LegalNotice from '../../components/LegalNotice/LegalNotice'
import PoliticaPrivacidad from '../../components/PoliticaPrivacidad'
import PoliticaCookies from '../../components/PoliticaCookies'
import WhatsappGroups from '../../components/WhatsappGroups'
import Footer from '../../components/Footer'
import TermsAndCondition from '../../components/TermsAndCondition/TermsAndCondition'
import '../../assets/styles/css/Legal.css'
import { TYPES_MENU_LIST } from '../../constants/menu'

const Home = () => {
  const { t } = useTranslation()
  const menuList = [
    {
      component: <LegalNotice />,
      id: TYPES_MENU_LIST.LEGAL_NOTICE,
      title: t('Aviso legal'),
    },
    {
      component: <PoliticaPrivacidad />,
      id: TYPES_MENU_LIST.PRIVACY_POLICY,
      title: t('Política de Privacidad'),
    },
    {
      component: <TermsAndCondition />,
      id: TYPES_MENU_LIST.TERMS_AND_CONDITIONS,
      title: t('Términos y condiciones de compra'),
    },
    {
      component: <PoliticaCookies />,
      id: TYPES_MENU_LIST.COOKIE_POLICY,
      title: t('Política de Cookies'),
    },
    {
      component: <WhatsappGroups />,
      id: TYPES_MENU_LIST.WHATSAPP_GROUPS,
      title: t('Grupos de Whatsapp'),
    },
  ]
  const [currentSelected, setCurrentSelected] = useState('')
  const [isStiky, setIsStiky] = useState(false)

  return (
    <div className={'wrapper'}>
      <div className={'navBar'}>
        <NavBarTop />
      </div>
      <div className={`${'container'} container`}>
        <div className={'legalCnt'}>
          <h1>
            {t('Aviso legal, política de privacidad y política de')}{' '}
            <i>{t('cookies')}</i>
          </h1>
          <div className={isStiky ? 'active' : 'inactive'}>
            <Sticky
              className={'anchors'}
              onFixedToggle={() => setIsStiky(!isStiky)}
              scrollElement='.container'
            >
              <ul>
                {menuList.map((menu) => {
                  return (
                    <a
                      className={currentSelected !== menu.id ? '' : 'selected'}
                      href={`#${menu.id}`}
                      key={menu.id}
                      onClick={() => setCurrentSelected(menu.id)}
                      role='presentation'
                    >
                      <li>{menu.title}</li>
                    </a>
                  )
                })}
              </ul>
            </Sticky>
            <div className={'legalText'}>
              {menuList.map((menu) => (
                <Fragment key={menu.id}>{menu.component}</Fragment>
              ))}
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default Home
